import { render, staticRenderFns } from "./StoreUpdateProject.vue?vue&type=template&id=4aaa513e&scoped=true&"
import script from "./StoreUpdateProject.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdateProject.vue?vue&type=script&lang=ts&"
import style0 from "./StoreUpdateProject.vue?vue&type=style&index=0&id=4aaa513e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa513e",
  null
  
)

export default component.exports